import { lazy, Suspense } from 'preact/compat';
import { Home } from './screens/Home';

// Dev tools are a separate chunk. __DEV_TOOLS__ is replaced with a literal at build time,
// so outside the dev flavor this import is dead code and the chunk is never emitted.
const DevTools = __DEV_TOOLS__
  ? lazy(() => import('./components/DevTools').then((m) => ({ default: m.DevTools })))
  : null;

export function App() {
  return (
    <>
      <Home />
      {DevTools && (
        <Suspense fallback={null}>
          <DevTools />
        </Suspense>
      )}
    </>
  );
}
